export default __webpack_public_path__ + "static/media/aavatar.884dd4af.png";